(function () {
    'use strict';

    angular
        .module('elogbooks.user.service-providers')
        .controller('UserServiceProvidersDetailsController', UserServiceProvidersDetailsController);

    UserServiceProvidersDetailsController.$inject = ['serviceProviderResponse', 'userResponse', 'elbSettings', 'modulesService'];

    function UserServiceProvidersDetailsController (serviceProviderResponse, userResponse, elbSettings, modulesService) {
        var vm = this;
        vm.serviceProvider = serviceProviderResponse;
        vm.user = userResponse;
        vm.reporterFeedbackEnabled = elbSettings.getSetting('job_reporter_feedback').value;
        vm.contractsModuleEnabled = modulesService.isEnabled('contracts_module');
        vm.assetsModuleEnabled = modulesService.isEnabled('assets_module');
    }
})();
